import { Link, link } from '../index';

export interface IPagerControlSetting {
    pageSize: number;
    itemsCount: number;
    startPage?: number;
    distance?: number;
    pageChange?: (newPage: number) => void;
}

const settingDefault: IPagerControlSetting = {
    pageSize: undefined,
    itemsCount: undefined,
    startPage: 0,
    distance: 1,
    pageChange: $.noop
};

export class PagerControl {
    private root: JQuery;
    private _currentPage: number;
    private setting: IPagerControlSetting;

    constructor(setting: IPagerControlSetting) {
        this.setting = $.extend({}, settingDefault, setting);
        this._currentPage = this.setting.startPage;
        this.root = $('<div>').addClass('pagerControl');
        this.refresh();
    }

    public refresh() {
        const pageCount = this.getPageCount();
        const distance = this.setting.distance;
        this.root.empty();
        if (pageCount <= 1) {
            return;
        }
        const startLine = Math.max(this._currentPage - distance, 1);
        const endLine = Math.min(this._currentPage + distance, pageCount - 1);
        this.appendPage(0);
        if (startLine > 1) {
            this.appendEllipseText();
        }
        for (let index = startLine; index <= endLine; index++) {
            this.appendPage(index);
        }
        if (pageCount - endLine > 1) {
            this.appendEllipseText();
        }
        this.appendPage(pageCount);
    }

    public getControl(): JQuery {
        return this.root;
    }

    private getPageCount() {
        return Math.ceil(this.setting.itemsCount / this.setting.pageSize) - 1;
    }

    public itemsCount(itemsCount?: number): number {
        if (itemsCount !== undefined) {
            this.setting.itemsCount = itemsCount;
            this.refresh();
        }
        return this.setting.itemsCount;
    }

    public currentPage(currentPage?: number) {
        if (currentPage !== undefined) {
            this._currentPage = currentPage;
            this.refresh();
        }
        return this._currentPage;
    }

    private appendPage(num: number) {
        const btn: Link = link({
            text: (num + 1).toString(),
            className: num === this._currentPage ? 'active' : ''
        });
        btn.click(() => {
            this._currentPage = num;
            this.refresh();
            this.setting.pageChange(num);
        });
        this.root.append(btn.getControl());
    }

    private appendEllipseText() {
        $('<span>').html('&hellip;').appendTo(this.root);
    }
}
